import React, { useEffect, useState } from "react";
import axios from "axios";
import { Link } from "react-router-dom";
import { FaFire } from "react-icons/fa";
import { PiNewspaperFill, PiNewspaperClippingFill } from "react-icons/pi";

type Editorial = {
  id: number;
  judul: string;
  gambar: string;
  views: string;
};

const SidebarPopular: React.FC = () => {
  const [popular, setPopular] = useState<Editorial[]>([]);
  const [otherNews, setOtherNews] = useState<Editorial[]>([]);
  const [othersList, setOthersList] = useState<Editorial[]>([]);

  const API = process.env.REACT_APP_API_BASE_URL;

  useEffect(() => {
    const fetchPopular = async () => {
      const res = await axios.get(`${API}/api/editorial-populer`);
      setPopular(res.data.data.slice(0, 10));
    };

    const fetchOthers = async () => {
      const res = await axios.get(`${API}/api/editorial`);

      setOtherNews(res.data.data.slice(0, 10));
      setOthersList(res.data.data.slice(4, 10));
    };

    fetchPopular();
    fetchOthers();
  }, [API]);

  return (
    <aside className="space-y-8">
      {/* POPULAR NEWS */}
      <div className="bg-white p-5 rounded-2xl shadow-md">
        <div className="flex items-center gap-2 text-xl font-bold mb-5 border-b pb-2">
          <FaFire className="text-primary" />
          <h3 className="">Isu Populer</h3>
        </div>

        <div className="space-y-4">
          {popular.map((item) => (
            <Link to={`berita/${item?.id}`} key={item.id} className="flex gap-3 items-start group cursor-pointer">
              <img src={item.gambar} alt="" className="w-20 h-16 object-cover rounded-lg" />

              <div>
                <p className="text-sm font-medium line-clamp-2 group-hover:text-primary transition">{item.judul}</p>

                <span className="text-xs text-gray-400">👁 {item.views}</span>
              </div>
            </Link>
          ))}
        </div>
      </div>

      {/* OTHER NEWS SAME DESIGN */}
      {/* <div className="bg-white p-5 rounded-2xl shadow-md">
        <div className="flex items-center gap-2 text-xl font-bold mb-5 border-b pb-2">
          <PiNewspaperFill className="text-primary" />
          <h3 className="">Berita Lainnya</h3>
        </div>

        <div className="space-y-4">
          {otherNews.map((item) => (
            <Link to={`berita/${item?.id}`} className="flex gap-3 items-start group cursor-pointer">
              <img src={item.gambar} alt="" className="w-20 h-16 object-cover rounded-lg" />

              <div>
                <p className="text-sm font-medium line-clamp-2 group-hover:text-primary transition">{item.judul}</p>

                <span className="text-xs text-gray-400">👁 {item.views}</span>
              </div>
            </Link>
          ))}
        </div>
      </div> */}

      {/* OTHER LIST */}
      {/* <div className="bg-white p-5 rounded-2xl shadow-md">
        <div className="flex items-center gap-2 text-xl font-bold mb-5 border-b pb-2">
          <PiNewspaperClippingFill className="text-primary" />
          <h3 className="">Berita Lainnya</h3>
        </div>

        <div className="space-y-3">
          {othersList.map((item, index) => (
            <Link to={`berita/${item?.id}`} key={item.id} className="flex items-start gap-3 group cursor-pointer">
              <span className="text-primary font-bold text-lg w-6">{index + 1}</span>

              <p className="text-sm text-gray-700 line-clamp-2 group-hover:text-primary transition">{item.judul}</p>
            </Link>
          ))}
        </div>
      </div> */}
    </aside>
  );
};

export default SidebarPopular;
